// extracted by mini-css-extract-plugin
module.exports = {"infoGrid":"infoGrid_infoGrid__3Ur8j","infoCard":"infoGrid_infoCard__2_Lss","infoCardButton":"infoGrid_infoCardButton__2E4WB","infoCardValue":"infoGrid_infoCardValue__3zdlp"};